export const DAM_SIRE_DOCUMENT = {
    ALLOWED_TYPES: ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "image/png", "image/jpeg"],
    MAX_SIZE: 20 * 1024 * 1024, // 20mb in bytes
    MAX_NAME_LENGTH: 255,
};
